import styled from 'styled-components'

const RoznicaCITRZiSRowStyle = styled.div`
  padding: 12px 8px 12px 20px;
  border-radius: 3px;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  margin-bottom: 4px;

  :hover {
    box-shadow: -5px 0px 0px 0px ${props => props.theme.palette.primary.main};
  }

  .name {
    grid-area: name;
    display: flex;
    align-items: center;
  }

  .from {
    grid-area: from;
    text-align: right;
  }

  .to {
    grid-area: to;
    text-align: right;
  }
`

export default RoznicaCITRZiSRowStyle
